import { render } from "./JourneyCreate.vue?vue&type=template&id=ec431bd2"
import script from "./JourneyCreate.vue?vue&type=script&lang=js"
export * from "./JourneyCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__